import { ScheduleFFHelpers } from '@frontend/schedule-helpers';
import { CalendarEventsPanel } from './Calendar/EventsPanel/CalendarEvents';
import { ScheduleAppointmentInfoPanel } from './schedule-appointment-info-panel';

export const ScheduleSidePanels = () => {
  const { isEnabled: isApptPanelFFEnabled } = ScheduleFFHelpers.useNewApptPanelFeatureFlag();
  return (
    <>
      <CalendarEventsPanel />
      {isApptPanelFFEnabled && <ScheduleAppointmentInfoPanel />}
    </>
  );
};
